import { useEffect } from "react";
import { useAppDispatch } from "@lib/stores";
import { ContentActions } from "@lib/stores/content/slices";

export function useGetContentProgress(
  shouldLoad: boolean,
  contentIds: string[]
) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (shouldLoad)
      dispatch(ContentActions.getContentEntitiesProgressAsync(contentIds));
  }, [shouldLoad, `${contentIds}`]);
}
